import { render, staticRenderFns } from "./PortraitIcon.vue?vue&type=template&id=3584c7ac&scoped=true"
import script from "./PortraitIcon.vue?vue&type=script&lang=js"
export * from "./PortraitIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3584c7ac",
  null
  
)

export default component.exports